export default class TagPolicy {
    static browse(user) {
        return user.hasPermissionTo('browse:tags');
    }

    /* eslint-disable-next-line no-unused-vars */
    static edit(user, tag) {
        return user.hasPermissionTo('edit:tags');
    }

    static add(user) {
        return user.hasPermissionTo('add:tags');
    }

    static destroy(user, tag) {
        return tag.canDelete;
    }
}
